export const sites = {
  Add_new_site: "Agregar nuevo sitio",
  Address: "Dirección",
  Address_1: "Dirección 1",
  Address_2: "Dirección 2",
  All_sites: "Todos los sitios",
  Applicability: "Aplicabilidad",
  Basic_information: "Información básica",
  City: "Ciudad",
  "Country_*": "País *",
  Create_assessment: "Crear evaluación",
  Create_new_site: "Crear nuevo sitio",
  edit: "Editar",
  Edit_site_details: "Editar detalles del sitio",
  Here_you_can_manage_all_sites_in_your_organization: "Aquí puede administrar todos los sitios de su organización.",
  "Name_*": "Nombre *",
  Postcode: "Código postal",
  Release_to_drop_the_files_here: "Suelte para soltar los archivos_aquí",
  "Relevant_standard_*": "Estándar relevante *",
  Save_site: "Guardar sitio",
  "Scope_of_applicability_*": "Ámbito de aplicabilidad *",
  "Site_coordinator_*": "Coordinador del sitio *",
  siteCoordinator: "Coordinador del sitio",
  siteName: "Nombre del sitio",
  Standard_Body: "Cuerpo estándar",
  Standards: "Normas",
  State: "Estado",
  Template: "Plantilla",
  create_site_from_template: "Crear un sitio desde un archivo de plantilla",
  You_can_upload_many_sites_in_the_same_file: "Puedes subir muchos sitios en el mismo archivo",
} as const;
